module.exports = __webpack_public_path__ + "static/media/portfolio15.b628f8b9.avif";